import * as Vue from "vue";
import {Component} from "vue-property-decorator";
import "./app.styl";
const template = require("./app.vue");

@Component({
  template: template
})
export class AppComponent extends Vue {

}

Vue.component("cmApp", AppComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/views/app/app.ts